import { mapState, mapMutations, mapActions } from 'vuex';

export const editScoreBoxMixins = {
  data() {
    return {
      currentPageNumWhenFocus: 0,
    };
  },
  computed: {
    ...mapState('card', {
      answerSignal: state => state.answerSignal,
      subjects: state => state.subjects,
      existHeight: state => state.existHeight,
      pageCell: state => state.pageCell,
      currentPageNum: state => state.currentPageNum,
      newTopicHeight: state => state.newTopicHeight,
    }),
  },
  methods: {
    ...mapMutations({
      setAnswerSignal: 'card/setAnswerSignal',
      setCurrentPageNum: 'card/setCurrentPageNum',
      updatePageCell: 'card/updatePageCell',
      updateSubjects: 'card/updateSubjects',
    }),
    handlerFocus() {
      console.log('handlerFocus', this.currentPageNumWhenFocus);
    },
    handlerBlur(data) {
      this.subjects.forEach(async (subject, index) => {
        if (subject.th == this.msg.th) {
          subject.setEditName(data);
          console.log('看看blur的信息', subject, this.currentPageNumWhenFocus, this.pageCell);
          await this.updatePageCell({
            // ...this.msg,
            currentIndexInPage: this.msg.currentIndexInPage,
            initDragHeight: this.msg.initDragHeight,
            editName: data,
            currentPageNumWhenFocus: this.msg.pageIndex,
          });
          await this.updateSubjects({
            index: index,
            data: subject,
          });
        }
      });
    },

    setSubjectScoreBoxInfo(subject, name) {
      subject.scoreBoxInfo = {
        name: name,
      };
    },
  },
};
